export default __webpack_public_path__ + "static/media/desktop-character.8385093e.svg";